import { produce } from "immer";
import { tFiltersAction, tFiltersState } from "./types";

const kDefaultModalsState: tFiltersState = {
  applications: {
    type: undefined,
    term: "",
    page: 1,
    prev: "",
    next: "",
  },
  connections: {
    connectionStatus: undefined,
    connectionSource: undefined,
    term: "",
    page: 1,
    prev: "",
    next: "",
  },
  customers: {
    term: "",
    page: 1,
    prev: "",
    next: "",
  },
  orders: {
    orderStatus: undefined,
    term: "",
    page: 1,
    prev: "",
    next: "",
  },
  payouts: {
    payoutStatus: undefined,
    page: 1,
    prev: "",
    next: "",
  },
  referrals: {
    page: 1,
    prev: "",
    next: "",
  },
  repMyBrands: {
    term: "",
    connectionStatus: "Active",
    page: 1,
    prev: "",
    next: "",
  },
  repMyRetailers: {
    term: "",
    connectionStatus: undefined,
    page: 1,
    prev: "",
    next: "",
  },
  retailersMyBrands: {
    term: "",
    connectionStatus: undefined,
    page: 1,
    prev: "",
    next: "",
  },
  salesReps: {
    term: "",
    page: 1,
    prev: "",
    next: "",
  },
};

export const FiltersReducer = produce<tFiltersState, [tFiltersAction]>((draft = kDefaultModalsState, action) => {
  switch (action.type) {
    case "CHANGE_FILTER_TERM":
      draft[action.payload.pageName].term = action.payload.value;
      draft[action.payload.pageName].page = 1;
      draft[action.payload.pageName].prev = "";
      draft[action.payload.pageName].next = "";
      return draft;
    case "CHANGE_FILTER_ORDER_STATUS":
      draft[action.payload.pageName].orderStatus = action.payload.value;
      draft[action.payload.pageName].page = 1;
      draft[action.payload.pageName].prev = "";
      draft[action.payload.pageName].next = "";
      return draft;
    case "CHANGE_FILTER_PAYOUT_STATUS":
      draft[action.payload.pageName].payoutStatus = action.payload.value;
      draft[action.payload.pageName].page = 1;
      draft[action.payload.pageName].prev = "";
      draft[action.payload.pageName].next = "";
      return draft;
    case "CHANGE_FILTER_CONNECTION_STATUS":
      draft[action.payload.pageName].connectionStatus = action.payload.value;
      draft[action.payload.pageName].page = 1;
      draft[action.payload.pageName].prev = "";
      draft[action.payload.pageName].next = "";
      return draft;
    case "CHANGE_FILTER_CONNECTION_SOURCE":
      draft[action.payload.pageName].connectionSource = action.payload.value;
      draft[action.payload.pageName].page = 1;
      draft[action.payload.pageName].prev = "";
      draft[action.payload.pageName].next = "";
      return draft;
    case "CHANGE_FILTER_APPLICATION_TYPE":
      draft[action.payload.pageName].type = action.payload.value;
      draft[action.payload.pageName].page = 1;
      draft[action.payload.pageName].prev = "";
      draft[action.payload.pageName].next = "";
      return draft;
    case "CHANGE_FILTER_PREV_PAGE":
      draft[action.payload.pageName].page = draft[action.payload.pageName].page - 1;
      draft[action.payload.pageName].prev = action.payload.value;
      draft[action.payload.pageName].next = "";
      return draft;
    case "CHANGE_FILTER_NEXT_PAGE":
      draft[action.payload.pageName].page = draft[action.payload.pageName].page + 1;
      draft[action.payload.pageName].prev = "";
      draft[action.payload.pageName].next = action.payload.value;
      return draft;
    case "RESET_FILTERS":
      return kDefaultModalsState;
    default:
      return draft;
  }
});
